<template>
    <base-page>
        <el-card style="margin: 5px 0px 5px 0px">
            <el-collapse accordion style="border: none">
                <el-collapse-item name="1" style="border: none">
                    <template slot="title">
                        <div slot="header" class="clearfix">
                            <titlu-pagina Titlu="Utilizatori penalizare" @on_add_clicked="show_dialog()" :AdaugaVisible="true" />
                        </div>
                    </template>
                    <div class="filtre">
                        <el-form @submit.prevent.native='refresh_info()'>
                            <el-row style="margin: 10px" class="input-group">
                                
                                <el-col class="input-element">
                                    <el-form-item label="Utilizator">
                                        <el-select v-model="Filters.IdUtilizator" class="full-width" filterable clearable placeholder="Toti">
                                            <el-option v-for="item in Info.utilizatori" :key="item.Id" :label="item.Nume" :value="item.Id"></el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>

                                <el-col class="input-element">
                                    <el-form-item label="Tip utilizator">
                                        <el-select v-model="Filters.TipUtilizator" class="full-width" multiple collapse-tags-tooltip placeholder="Toate tipurile">
                                            <el-option label="Receptie" value="Receptie"></el-option>
                                            <el-option label="Mecanic" value="Mecanic"></el-option>
                                            <el-option label="Supervizor" value="Supervizor"></el-option>
                                            <el-option label="Management" value="Management"></el-option>
                                            <el-option label="Ajutor montator" value="AjutorMontator"></el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>

                                <el-col class="input-element">
                                    <el-form-item label="Luna">
                                        <el-date-picker
                                            v-model="Filters.Luna"
                                            type="month"
                                            placeholder="Toate lunile"
                                            class="full-width"
                                            value-format="yyyy-MM-dd"
                                        >
                                        </el-date-picker>
                                    </el-form-item>
                                </el-col>
                            </el-row>

                            <el-row :gutter="20">
                                <el-col :span='24'>
                                    <el-button type='primary' native-type='submit' @click='refresh_info()'> Aplica </el-button>
                                    <el-button type='danger' native-type='submit' @click='reset()'> Reseteaza </el-button>
                                </el-col>
                            </el-row>
                        </el-form>
                    </div>
                </el-collapse-item>
            </el-collapse>
        </el-card>

        <el-table :data="Results" stripe border style="width: 100%">
            <el-table-column prop="NumeUtilizator" label="Utilizator" sortable></el-table-column>
            
            <el-table-column prop="TipUtilizator" label="Tip" width="150"></el-table-column>
            
            <el-table-column label="Data" width="180">
                <template slot-scope="scope">
                    <i class="el-icon-date"></i> {{ formatDate(scope.row.Data) }} </template>
            </el-table-column>

            <el-table-column label="Valoare" width="150">
                <template slot-scope="scope">
                    <span style="color: #F56C6C; font-weight: bold;">-{{ scope.row.Valoare }} RON</span> </template>
            </el-table-column>

            <el-table-column prop="Motiv" label="Motiv"></el-table-column>

            <el-table-column align="right" fixed="right" label="Actiuni" width="120px">
                <template slot-scope="scope">
                    <el-tooltip content="Modifica">
                        <el-button type="primary" icon="el-icon-edit" circle size="small"
                            @click="show_dialog(scope.row.Id)" />
                    </el-tooltip>

                    <el-tooltip content="Sterge">
                        <el-button type="danger" icon="el-icon-delete" circle size="small"
                            @click="delete_item(scope.row)" />
                    </el-tooltip>
                </template>
            </el-table-column>
        </el-table>

        <el-pagination @size-change="refresh_info" @current-change="refresh_info"
            :page-size.sync="PaginationInfo.PerPage" :current-page.sync="PaginationInfo.Page"
            :total="PaginationInfo.RowCount" layout="pager" />

        <Penalizari-dialog ref='dlg' @save="refresh_info()" />

    </base-page>
</template>

<script>
import BasePage from "@/pages/Admin/BasePage";
import Utilizatori_penalizare_dialog from '@/pages/Admin/utilizatori/Utilizatori_penalizare_dialog.vue';
import TitluPagina from '@/widgets/TitluPagina';

export default {
    name: "utilizatori_penalizare_list",
    extends: BasePage,
    components: {
        'base-page': BasePage,
        'Penalizari-dialog': Utilizatori_penalizare_dialog,
        'titlu-pagina': TitluPagina
    },
    data() {
        return {
            Results: [],
            Info: {
                utilizatori: [] 
            },
            Filters: {
                IdUtilizator: '', 
                TipUtilizator: [], 
                Luna: ''
            },
            PaginationInfo: { Page: 1, PerPage: 50, RowCount: 0, PageSizes: [10, 25, 50, 100] },
        }
    },
    methods: {
        async get_info() {
            var response = await this.post("utilizatori_penalizari/get_all_users");
            this.Info.utilizatori = response.Results || response;
            this.refresh_info();
        },

        async refresh_info() {
            var response = await this.post("utilizatori_penalizari/index", { 
                Filters: this.Filters, 
                PaginationInfo: this.PaginationInfo 
            });
            this.Results = response.Results;
            this.PaginationInfo = response.PaginationInfo;
        },

        reset() {
            this.Filters = {
                IdUtilizator: '', 
                TipUtilizator: [], 
                Luna: ''
            };
            this.refresh_info();
        },

        async delete_item(item) {
            var confirm = await this.$confirm(`Sunteti sigur ca vreti sa stergeti penalizarea pentru ${item.NumeUtilizator}?`, 'Atentie', {
                confirmButtonText: 'Da',
                cancelButtonText: 'Nu',
                type: 'warning'
            });
            if (confirm) {
                await this.post("utilizatori_penalizari/delete_item", { id: item.Id });
                this.refresh_info();
            }
        },

        show_dialog(id) {
            this.$refs.dlg.show_me(id, this.Info.utilizatori);
        },

        formatDate(dateString) {
            if(!dateString) return '-';
            const date = new Date(dateString);
            const options = { year: 'numeric', month: 'long' };
            return date.toLocaleDateString('ro-RO', options);
        }
    },
    mounted() {
        this.get_info();
    }
};
</script>

<style lang="less" scoped>
.input-element {
    width: 23%;
    margin-right: 2%;
}

@media only screen and (max-width: 600px) {
    .input-element {
        width: 100%;
        margin-right: 0;
        margin-bottom: 10px;
    }
}
</style>